import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBackIos } from "react-icons/md";
import Button from "shared/components/Button";
import Header from "shared/components/Header/Header";
import { NAME_SPACES } from "shared/locales/constants";
import ContractConfig from "../components/ContractConfig";
import DeploymentManager from "../components/DeploymentManager";
import EnterpriseInfo from "../components/EnterpriseInfo";

const TABS = {
  INFO: "info",
  CONFIG: "config",
  DEPLOYMENT: "deployment",
  TRACKING: "tracking",
};

export default function EnterpriseDashboard({ enterprise, onBack, onSubmit }) {
  const [activeTab, setActiveTab] = useState(TABS.INFO);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.COMPANY);
  const DETAIL = t("DETAIL", { returnObjects: true });

  const tabsConfig = [
    { key: TABS.INFO, label: DETAIL.TABS.INFO },
    { key: TABS.CONFIG, label: DETAIL.TABS.CONFIG },
    { key: TABS.DEPLOYMENT, label: DETAIL.TABS.DEPLOYMENT },
    // { key: TABS.TRACKING, label: DETAIL.TABS.TRACKING },
  ];

  return (
    <>
      <Header title={DETAIL.HEADER.TITLE} />
      <div>
        <Button onClick={onBack} type="secondary--link">
          <MdArrowBackIos className="company__w-5 company__h-5" />
          {DETAIL.HEADER.BACK}
        </Button>

        <div className="company__bg-white company__rounded-lg company__border company__border-slate-200 company__p-6 company__mb-6">
          <div className="company__flex company__items-start company__gap-4">
            {enterprise.icon && (
              <img
                src={enterprise.icon}
                alt={enterprise.name}
                className="company__w-16 company__h-16 company__rounded-lg"
                style={{ objectFit: "cover" }}
              />
            )}
            <div>
              <h2 className="company__text-2xl company__font-semibold company__text-slate-900">
                {enterprise.name}
              </h2>
              {enterprise.siretNumber && (
                <p className="company__text-slate-600 company__mt-1">
                  {t("LIST.SIRET")}: {enterprise.siretNumber}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="company__bg-white company__rounded-lg company__border company__border-slate-200">
          <div className="company__border-b company__border-slate-200">
            <nav className="company__flex">
              {tabsConfig.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`company__tab company__px-6 company__py-4 company__font-medium ${
                    activeTab === tab.key
                      ? "company__tab--active"
                      : "company__text-slate-600"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="company__p-6">
            {activeTab === TABS.INFO && (
              <EnterpriseInfo enterprise={enterprise} onSubmit={onSubmit} />
            )}
            {activeTab === TABS.CONFIG && (
              <ContractConfig enterprise={enterprise} />
            )}
            {activeTab === TABS.DEPLOYMENT && (
              <DeploymentManager enterpriseId={enterprise.id} />
            )}
            {/* {activeTab === TABS.TRACKING && (
              <EnrollmentTracking
                enterpriseId={enterprise.id}
                onNavigateToDeployment={() => setActiveTab(TABS.DEPLOYMENT)}
              />
            )} */}
          </div>
        </div>
      </div>
    </>
  );
}
